export const getAddressSuggestions = async (val, geoKey) => {
  if (!geoKey) {
    console.error("Geoapify API key missing");
    return [];
  }

  try {
    const res = await fetch(
      `https://api.geoapify.com/v1/geocode/autocomplete?text=${encodeURIComponent(val)}&filter=countrycode:us,ca&apiKey=${geoKey}`
    );
    const data = await res.json();
    return data.features || [];
  } catch (err) {
    console.error(err);
    throw err;
  }
};